export const formatMonthYear = (date: Date): string => {
  const month = String(date.getMonth() + 1).padStart(2, '0'); // 01 → 12
  const year = date.getFullYear();
  return `${month}.${year}`;
};
